/*
 * @Author: tom
 * @Date: 2022-07-30 16:56:44
 * @Description:
 */
import { createRouter, createWebHashHistory } from "vue-router";
import { LoadingPage, TAB_BAR_LIST } from "@/config";
import { useAppStore } from "@/store";
import authStore from "@/store/AuthStore";
import { wxInit } from "@/utils/wx";

const routes = [
  {
    path: "/",
    redirect: "/loading",
    children: [
      { path: "loading", component: () => import("@/views/loading/index.vue") },
      { path: "home", component: () => import("@/views/home/index.vue") },
      { path: "bbs", component: () => import("@/views/bbs/index.vue") },
      {
        path: "question",
        component: () => import("@/views/question/index.vue"),
      },
      {
        path: "calendar",
        component: () => import("@/views/calendar/index.vue"),
      },
      { path: "about", component: () => import("@/views/about/index.vue") },
      {
        path: "agreement/:src",
        component: () => import("@/views/agreement/index.vue"),
      },
      {
        path: "myagreement",
        component: () => import("@/views/about/myagreement/index.vue"),
      },
      {
        path: "useragreement",
        component: () => import("@/views/agreement/useragreement.vue"),
      },
    ],
  },
  {
    path: "/divination-result",
    name: "DivinationResult",
    component: () => import("@/views/divination/result/index.vue"),
  },
  {
    path: "/divination-ai-result-pay",
    name: "DivinationAIResultPay",
    component: () => import("@/views/divination/airesultpay/index.vue"),
  },
  {
    path: "/divination-ai-result",
    name: "DivinationAIResult",
    component: () => import("@/views/divination/airesult/index.vue"),
  },
  {
    path: "/test",
    component: () => import("@/views/unitest/index.vue"),
    children: [
      {
        path: "poup",
        component: () => import("@/views/unitest/poup.vue"),
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    name: "notFound",
    redirect: "/loading",
  },
];
const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    return { left: 0, top: 0 };
  },
});

const tabUrlList = TAB_BAR_LIST.map((item) => item.url);
router.beforeEach((to: any, from) => {
  const appStore = useAppStore();
  if (to.href) {
    if (
      !to.href.includes("loading") &&
      (!authStore.getToken() || !authStore.token)
    ) {
      window.location.replace(LoadingPage);
      return false;
    }
    let toHref = `/${to.href}`;
    if (toHref.includes("?")) {
      toHref = toHref.split("?")[0];
    }
    const index = tabUrlList.indexOf(toHref);
    if (index !== -1) {
      appStore.setTabActive(index);
      appStore.setShowTabBar(true);
      document.title = TAB_BAR_LIST[index].text;
    } else {
      appStore.setTabActive(-1);
      appStore.setShowTabBar(false);
    }
  }
  return true;
});

router.afterEach(() => {
  wxInit().then();
});
export default router;
